import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";

export const useCultureReducer = () => useSelector((state: ApplicationState) => state.culture);
